export const loadColorCode = (data) => {
    let spo2 = data.value;
    let signal_quality = data.type;
    
    //         If the spo2 < 90 #E51414
    //  If the spo2 between 90 and 94 #F7B500
    //  If the spo2 greater than 94 #56E4D7
    // If the device signals are bad, it’s #808080
    if (!spo2 || spo2 === "--" || signal_quality ==="bad") {
        return {
            color: "#808080"
        }
    }

    if (spo2 < 90) {
        return ({
            color: "#F75F56"
        })
    } else if (spo2 <= 94) {
        return ({
            color: "#F7B500"
        })
    } else if (spo2 > 94) {

        return ({
            color: "var(--primary-theme-color)"
        })
    } else {
        return ({
            color: "#808080"
        })
    }
}

export const getSpo2Value = (fData,item)=>{
    let data = {
        value:'',
        type:''
    }
    
    if(fData[String(item?.user_id)]){
        

        let lastElement = fData[String(item?.user_id)][
                    fData[String(item?.user_id)]?.length - 1
                  ];
                  if(lastElement?.spo2 && lastElement?.signal_quality){
                    // return lastElement.spo2;
                    data.value = lastElement.spo2;
                    data.type = 'ok'
                  }else if (!lastElement?.signal_quality && lastElement?.spo2 && lastElement?.spo2 > 80 ){
                    // return lastElement.spo2;
                    data.value = lastElement.spo2;
                    data.type = 'bad'
                  }
                  else{
                    data.value = '--';
                    data.type = 'bad'
                  }
                  return data;
    }else{
        return {
            value:'--',
            type:'bad'
        }
    }
//     return fData[String(item?.user_id)][
//         fData[String(item?.user_id)]?.length - 1
//       ]?.spo2
//         ? fData[String(item?.user_id)][
//             fData[String(item?.user_id)]?.length - 1
//           ]?.spo2
//         : "-"
}